<script>
    import { onMount, onDestroy } from 'svelte';

    let timeout;
    onMount(() => {
        timeout = setTimeout(() => {
            window.location.href = cpaUrl;
        }, 7000);
    })

    onDestroy(() => {

    })
    export let locale = 'ru-RU';

    export let headBackgroundColor = '#F2F2F2';
    export let headBorderBottomColor = '#F2F2F2';

    export let cpaUrl = 'https://zencpa.ru';

    export let show = false;

    function hide() {
        show = false;
    }

</script>

{#if show}
<div class="zencpa-modal-wrap">
    <div class="zencpa-modal-header" style={`
        background-color: ${headBackgroundColor};
        border-bottom: 1px solid ${headBorderBottomColor};
    `}>
        <div class="title-wrap">
            Зарабатывайте вместе с нами в ZenCpa!
        </div>
        <a href="/nojs.html" class="close-btn-wrap" on:click|preventDefault={hide}>
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.3825 6.7692L23.2309 7.6176L7.61769 23.2296L6.76929 22.3818L22.3825 6.7692Z" fill="black"/>
                <path d="M7.61769 6.7692L23.2309 22.3812L22.3825 23.2302L6.76929 7.6182L7.61769 6.7692Z" fill="black"/>
            </svg>
        </a>
    </div>
    <div class="zencpa-modal-body">
        <p class="intro-text">
            Теперь раздел партнерской программы находится на сайте zencpa.ru!<br />
            Переходите и начинайте зарабатывать!
        </p>

        <div class="button-wrap">
            <a href={cpaUrl} class="link-btn">Перейти на ZenCpa</a>
        </div>

        <p class="outro-text">
            Вы будете перенаправлены автоматически через 7 секунд.
        </p>
    </div>
</div>
{/if}

<style>
    .zencpa-modal-header {
        padding-top: 20px;
        padding-bottom: 20px;

        color: #333;
        text-align: center;
        font-size: 18px;

        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }
    .zencpa-modal-body {
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 25px;
    }
    .intro-text, .outro-text {
        color: #4F4F4F;
        font-size: 16px;
        font-weight: 300;
        line-height: 25px;
        letter-spacing: 0.24px;
        margin-bottom: 18px;

        text-align: center;
    }
    .button-wrap {
        margin-bottom: 18px;
    }
    a.link-btn:hover, a.link-btn:focus {
        text-decoration: none;
    }
    .link-btn {
        border-radius: 10px;
        background: #11998E;
        box-shadow: 0px 2px 10px 0px rgba(17, 153, 142, 0.25);

        width: 251px;
        height: 53px;
        padding-top: 17px;
        padding-bottom: 17px;
        font-size: 14px;
        margin-left: auto;
        margin-right: auto;
        display: block;
        text-align: center;
        color: #fff;
    }
    .zencpa-modal-wrap {
        border-radius: 15px;
        background: #F2F2F2;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.25);

        width: 544px;
        height: 305px;
        overflow: hidden;

        font-family: Roboto;
    }

    @-moz-keyframes spin {
        100% { -moz-transform: rotate(360deg); }
    }
    @-webkit-keyframes spin {
        100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform:rotate(360deg);
        }
    }
    .spinner {
        -webkit-animation:spin 2s linear infinite;
        -moz-animation:spin 2s linear infinite;
        animation:spin 2s linear infinite;
    }


</style>